<div class="container-fluid wrapper-page">

  <div class="page-head">
    <h5 class="header-title heading-color">Generate Coupon</h5>
  </div>
  <div class="card">
    <ng-container>
      <section class="mt-3 m-b-15 align-items-center">

        <form [formGroup]="couponGenerateForm">

          <!--Coupon Description-->
          <div class="row">
            <div class="col-sm ml-20"></div>
            <div class="col-sm-3 ml-20">
              <label class="f-s-13 mr-2 mt-3 font-weight-bold">Description :</label>
            </div>
            <div class="col-sm-4">
              <input formControlName="description" type="text" class="form-control font-weight-100 ml-1">
              <div *ngIf="couponGenerateForm.get('description').hasError('required')" class="invalid-feedback ml-1">
                Description is <strong>required</strong>.
              </div>
            </div>
            <div class="col-sm ml-20"></div>
          </div>
          <br>

          <!--Discount Percentage-->
          <div class="row">
            <div class="col-sm ml-20"></div>
            <div class="col-sm-3 ml-20">
              <label class="f-s-13 mr-2 mt-3 font-weight-bold">Discount Percentage :</label>
            </div>

            <div class="col-sm-4">
              <div class="d-flex">
                <input formControlName="discount_percent" type="number" class="form-control font-weight-100 ml-1">
                <span class="fa fa-percent ml-2 mt-3" style="font-size:18px"></span>
              </div>
              <div *ngIf="couponGenerateForm.get('discount_percent').hasError('required')"
                class="invalid-feedback ml-1">
                Discount Percentage is <strong>required</strong>.
              </div>
              <div *ngIf="couponGenerateForm.get('discount_percent').hasError('pattern')" class="invalid-feedback ml-1">
                Discount Percentage is <strong>invalid (Valid Range 1 -100)</strong>.
              </div>
            </div>

            <div class="col-sm ml-20"></div>
          </div>
          <br>

          <!--Valid from Date-->
          <div class="row">
            <div class="col-sm ml-20"></div>
            <div class="col-sm-3 ml-20">
              <label class="f-s-13 mr-5 mt-3 font-weight-bold">Valid From :</label>
            </div>
            <div class="col-sm-4">
              <div class="d-flex">
                <input formControlName="valid_from" placeholder="Start Date(DD/MM/YYYY)" ngbDatepicker
                  #sd="ngbDatepicker" data-date-inline-picker="false" id="valid_from" [minDate]="currentDate"
                  class="form-control font-weight-100 ml-1">
                <div>
                  <button class="btn btn-outline-secondary calendar rounded-0" (click)="sd.toggle()" type="button"
                    style="line-height: 2.5;" id="startDateButton">
                    <span class="fa fa-calendar"></span>
                  </button>
                </div>
              </div>
              <div *ngIf="couponGenerateForm.get('valid_from').hasError('required')" class="invalid-feedback  ml-1">
                Start Date is <strong>required</strong>.
              </div>
              <div
                *ngIf="!couponGenerateForm.get('valid_from').hasError('required') && couponGenerateForm.get('valid_from').hasError('ngbDate')"
                class="invalid-feedback  ml-1"> Start Date is <strong>invalid</strong>
              </div>
            </div>
            <div class="col-sm ml-20"></div>
          </div>
          <br>

          <!--Valid To Date-->
          <div class="row">
            <div class="col-sm ml-20"></div>
            <div class="col-sm-3 ml-20">
              <label class="f-s-13 mr-5 mt-3 font-weight-bold">Valid To :</label>
            </div>
            <div class="col-sm-4">
              <div class="d-flex">
                <input formControlName="valid_to" placeholder="End Date(DD/MM/YYYY)" ngbDatepicker #ed="ngbDatepicker"
                  data-date-inline-picker="false" id="valid_to"
                  [minDate]="couponGenerateForm.value.valid_from || currentDate"
                  class="form-control font-weight-100 ml-1">
                <div>
                  <button class="btn btn-outline-secondary calendar rounded-0" (click)="ed.toggle()" type="button"
                    style="line-height: 2.5;" id="endDateButton">
                    <span class="fa fa-calendar"></span>
                  </button>
                </div>
              </div>
              <div *ngIf="couponGenerateForm.get('valid_to').hasError('required')" class="invalid-feedback  ml-1">
                End Date is <strong>required</strong>.
              </div>
              <div
                *ngIf="!couponGenerateForm.get('valid_to').hasError('required') && couponGenerateForm.get('valid_to').hasError('ngbDate')"
                class="invalid-feedback  ml-1"> End Date is <strong>invalid</strong>
              </div>
            </div>
            <div class="col-sm ml-20"></div>
          </div>
          <br>

          <!--Applicable To-->
          <div class="row">
            <div class="col-sm ml-20"></div>
            <div class="col-sm-3 ml-20">
              <label class="f-s-13 mr-5 mt-3 font-weight-bold">Applicable To :</label>
            </div>
            <div class="col-sm-4">
              <select class="form-control font-weight-100 ml-1" formControlName="scope">
                <option *ngFor="let appTo of coupApplicableTo" [ngValue]="appTo">{{appTo}}</option>
              </select>
              <div *ngIf="couponGenerateForm.get('scope').hasError('required')" class="invalid-feedback ml-1">
                Applicable To is <strong>required</strong>.
              </div>
            </div>

            <div class="col-sm ml-20"></div>
          </div>
          <br>
          <br>

          <div class="row align-items-center">
            <div class="col-sm-4"></div>

            <div class="col-sm-3">
              <button type="button" class="btn btn-primary btn-model w-100 mb-3" (click)="couponCreate()"
                [disabled]="couponGenerateForm.invalid">Generate</button>
            </div>
            <div class="col-sm-4"></div>

          </div>


        </form>

      </section>
    </ng-container>
  </div>

</div>